import {default as archive_setup} from './archive-list';

export default function () {
    archive_setup();
}

